import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { getData, modifyData } from "../../../redux/slices/MasterJobTypeSlice";
import { ToastContainer } from "react-toastify";
import { toastMessage } from "../../../helpers/utility.js";
// import DeleteConfirmationModal from "../../../pagecomponents/Common/DeleteConfirmationModal";
import PageWrapper from "../../../pagecomponents/Common/PageWrapper";
import ModalWrapper from "../../../pagecomponents/Common/ModalWrapper";
import JobTypeAddEditForm from "./AddEditForm";
import DataTable from "../../../pagecomponents/Common/DataTable";
import Swal from "sweetalert2";
import { deleteMasterData } from "../../../redux/api-calls/deleteMasterData.js";
import { MASTER_DATA_TYPE } from "../utils/constnsts.js";

const INIT_FORM_DATA = { job_type_master_Id: 0, job_type_Name: "", job_type_Code: "", type: "", client_Id: 1 };

const JobTypeIndex = () => {
    const dispatch = useDispatch();
    const pageName = "Job Type";
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [totalPage, setTotalPage] = useState(0);

    const PARAMS = {
        skip: 0,
        take: rowsPerPage,
        type: "job_type",
        sorting: 'asc',
        sorting_key: 'created_at',
        filter: {
            
        }
    };
    
    const [data, setData] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    // const [deleteAlertVisible, setDeleteAlertVisible] = useState(false);
    const [params, setParams] = useState(PARAMS);
    const [formData, setFormData] = useState(INIT_FORM_DATA);
    const [isEdit, setIsEdit] = useState(false);
    // const [isDelete, setIsDelete] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isSaveDisabled, setIsSaveDisabled] = useState(false);
    

    

    useEffect(() => {
        fetchMasterData();
    }, [params]);

    

    const fetchMasterData = async () => {
        setIsLoading(true);
        
        try {
            const { payload } = await dispatch(getData({ inputData: params }));
            setData(payload.job_type);
            setTotalPage(Math.ceil(payload.job_type_count/rowsPerPage));
        } catch (err) {
            toastMessage("error", "Failed to fetch data");
        } finally {
            setIsLoading(false); // Stop loader
        }
    };
        
    const handleSave = async (formData) => {
        console.log(formData);
        setIsSaveDisabled(true);
        
        const { payload } = await dispatch(modifyData({ inputData: formData }));
        if (payload?.status === "error") {
            setIsSaveDisabled(false);
            toastMessage("error", payload.msg || "An error occurred while saving.");
        } else {

            if(formData.type === 'delete') {
                setIsSaveDisabled(false);
                Swal.fire("Deleted!", "Your file has been deleted.", "success");
            } else {
                setIsSaveDisabled(false);
                toastMessage(payload?.status || "success", payload?.msg || "Operation successful.");
                closeModal();
            }
            fetchMasterData();
        }
    };

    // Event handlers

    const openAddModal = () => {
        setIsEdit(false);
        setFormData(INIT_FORM_DATA);
        setModalVisible(true);
    };

    const openEditModal = (item) => {
        setIsEdit(true);
        setFormData({ ...item, job_type_Code: item.job_type_Code || "", type: item.type || "" });
        setModalVisible(true);
    };

    const handleDelete = async (item) => {
        const data = await deleteMasterData({type: MASTER_DATA_TYPE.JOB_TYPE, id: item.job_type_master_Id})
        if(data.error || data.status === "error") {
            toastMessage("error",data.msg ?? data.error ?? "An error occurred while saving.");
        }
        fetchMasterData();
    };

    const closeModal = () => {
        setModalVisible(false);
        // setValidated(false);
        setFormData(INIT_FORM_DATA);
    };

    const handleSort = (key) => {
        setCurrentPage(1);
        
        setParams((prev) => ({
            ...prev,
            skip: 0,
            sorting_key: key,
            sorting: prev.sorting_key === key && prev.sorting === "asc" ? "desc" : "asc",
        }));
    };

    const handleRowsPerPageChange = (rows) => {
        setRowsPerPage(rows);
        setCurrentPage(1);
        
        setParams((prev) => ({
          ...prev,
          take: rows,
          skip: 0,
        }));
    };

    const setPage = (pagenum) => {
        setCurrentPage(pagenum);
        setParams((prev) => ({
            ...prev,
            skip: (pagenum - 1) * prev.take,
        }));
    };

    const columns = [
        {label: "#", accessor: "index", sortable: false, width: "10%"},
        {label: "Name", accessor: "job_type_Name", sortable: true, width: "50%"},
    ];

    return(
        <>
            <ToastContainer />
            <PageWrapper 
                pageName={pageName}
                headerBtnTitle="+ Job Types"
                onHeaderButtonClick={() => {openAddModal()}}
                showAddBtn={true}
            >
                <DataTable 
                    pageName={pageName}
                    columns={columns} 
                    data={data} 
                    onEdit={openEditModal}
                    onDelete={handleDelete}
                    deleteEnabled
                    onSorting={handleSort}
                    sortingState={{ key: params.sorting_key, order: params.sorting }}
                    currentPage={currentPage}
                    totalPages={totalPage}
                    rowsPerPage={rowsPerPage}
                    updateRowsPerPage={handleRowsPerPageChange}
                    onPageChange={setPage}
                    loader={isLoading}
                />
            </PageWrapper>

            <ModalWrapper
                visible={modalVisible}
                onClose={closeModal}
                modalTitle={`${isEdit ? "Edit" : "Add"} ${pageName}`}
            >
                <JobTypeAddEditForm
                    saveData={handleSave}
                    closeModal={closeModal}
                    formPayload={formData}
                    isSaveDisabled={isSaveDisabled} 
                />
            </ModalWrapper>
        </>
    );
};

export default JobTypeIndex;